<template>
  <section class="data-deletion-header">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 mx-auto text-center">
          <DataDeletionIcon />
          <DataDeletionTitle />
          <StoreComplianceBadges />
          <LastUpdate />
        </div>
      </div>
    </div>
    <PrivacyWave start-color="#f8f9fa" end-color="#f8f9fa" />
  </section>
</template>

<script>
import DataDeletionIcon from '../../components/cancellazione/header/DataDeletionIcon.vue'
import DataDeletionTitle from '../../components/cancellazione/header/DataDeletionTitle.vue'
import StoreComplianceBadges from '../../components/cancellazione/header/StoreComplianceBadges.vue'
import LastUpdate from '../../components/cancellazione/header/LastUpdate.vue'
import PrivacyWave from '../../components/privacy/header/PrivacyWave.vue'

export default {
  name: 'DataDeletionHeader',
  components: {
    DataDeletionIcon,
    DataDeletionTitle,
    StoreComplianceBadges,
    LastUpdate,
    PrivacyWave
  }
}
</script>

<style scoped>
.data-deletion-header {
  padding: 100px 0 140px;
  background: #2a5298;
  color: white;
  position: relative;
  overflow: visible;
}

.data-deletion-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><defs><pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse"><path d="M 100 0 L 0 0 0 100" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
  z-index: 0;
}

.data-deletion-header .container {
  position: relative;
  z-index: 2;
}

@media (max-width: 768px) {
  .data-deletion-header {
    padding: 80px 0 100px;
  }
}
</style>
